/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterVisitDto } from '../../models/filter-visit-dto';
import { ResponseVisitDto } from '../../models/response-visit-dto';

export interface VisitsControllerFilter$Params {
  
    /**
     * The filtering criteria
     */
    body: FilterVisitDto
}

export function visitsControllerFilter(http: HttpClient, rootUrl: string, params: VisitsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseVisitDto>>> {
  const rb = new RequestBuilder(rootUrl, visitsControllerFilter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseVisitDto>>;
    })
  );
}

visitsControllerFilter.PATH = '/thalea-pathways/visits/filter';
